import { WeaTools } from 'ecCom'

export const getTabInfo = (params) => {
    return WeaTools.callApi('/api/hrm/finance/getTabInfo', 'GET', params);
}

export const getFormField = (params) => {
    return WeaTools.callApi('/api/hrm/finance/getHrmFinanceFields', 'GET', params);
}

export const getSearchList = (params) => {
    return WeaTools.callApi('/api/hrm/finance/getHrmResourceSalaryLog', 'GET', params);
}

export const saveFormFields = (params) => {
    return WeaTools.callApi('/api/hrm/finance/save', 'POST', params);
}





// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/finance.js